import React from 'react'
import { DeviveHeaderText, ReservedButton, StyledBody, StyledModalDevice } from './styles'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { DeviceNotConnectedIcon, SuccessDeviceIcon } from '../../utils/icons'




function DeviceConnectedPopup( {devicePopup,closeModal,title,connected,openConnectDevice,history}) {


  const ConnectDevice = () => {

    closeModal();
    openConnectDevice();
  }


  const hideBannerPermanently = () => {
    localStorage.setItem("hide_device_connect_banner", "true");
  };


  return (
    <StyledModalDevice show={devicePopup} >
      <Modal.Header closeButton onHide={closeModal} style={{ background: "white" }}>
        <DeviveHeaderText>
          <div className="subContainer">
            <div className="popupHeading">
              <span className="icon">{ connected ? SuccessDeviceIcon () : DeviceNotConnectedIcon()}</span>  {title}
            </div>
          </div>
        </DeviveHeaderText>
      </Modal.Header>
      <StyledBody isPadding={"0px 20px 20px 20px !important"}>
        {connected ? 
          <div className="message"> You have connected ${`Google fit`} to Woliba <br/> you can view your connected device by <br/> clicking on CTA  </div> :
          <div className="message">  You can connect your device by clicking on <br/> Connect device CTA or can view the <br/>banner in wellness tab </div>}
 
        <div className="wrapper-button" style={{marginTop: connected ? "40px" : "78px"}} >
          {connected ? 

            <ReservedButton
              width={"100px"}
              margin={"20px 0 0 0"}
              onClick={() => closeModal()}
            >
             Close
            </ReservedButton> :
           
            <ReservedButton
              width={"200px"}
              margin={"20px 0 0 0"}
              // onClick={() => openConnectDevice()}
              onClick={()=> { 
                hideBannerPermanently();
                history.push({pathname:"/profile",state:{key:6}})}}
            >
             View Wellness Tab
            </ReservedButton>}

          <ReservedButton
            width={"200px"}
            active={1}
            margin={"20px 0 0 0"}
            onClick={() => {
              hideBannerPermanently();
              ConnectDevice()}}
          >
            Connect  Device
          </ReservedButton>
        </div>
      </StyledBody>
      
    </StyledModalDevice>
  )
}


DeviceConnectedPopup.propTypes ={
  devicePopup: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  title:PropTypes.string.isRequired,
  connected:PropTypes.bool.isRequired,
  openConnectDevice:PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
}

export default DeviceConnectedPopup
